// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"a5-z","colorTextValue":"b5-z","swatches":"c5-z","collapseLink":"d5-z","isCollapsed":"e5-z","dropdown":"f5-z","disabled":"g5-z"};